import React, { useMemo } from "react";

import { zodResolver } from "@hookform/resolvers/zod";
import { ShieldCheck } from "lucide-react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button } from "@/src/components/ui/button";

import LoginField from "./LoginField";
import { createOtpSchema } from "./loginSchemas";

import type { JSX } from "react";

import type { OtpFormValues } from "./loginSchemas";

interface LoginAdmin2faFormProps {
  backToSignin: () => void;
  onSubmit: (values: OtpFormValues) => void;
}

function LoginAdmin2faForm({
  backToSignin,
  onSubmit,
}: LoginAdmin2faFormProps): JSX.Element {
  const { t } = useTranslation(["login", "common"]);

  const schema = useMemo(() => createOtpSchema(t), [t]);
  const methods = useForm<OtpFormValues>({
    defaultValues: { otpToken: "" },
    mode: "onBlur",
    resolver: zodResolver(schema),
  });

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FormProvider {...methods}>
      <form
        noValidate
        className="flex w-full flex-col gap-5"
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <LoginField
          autoComplete="one-time-code"
          icon={ShieldCheck}
          label={t("otpToken")}
          name="otpToken"
          placeholder={t("otpToken")}
        />

        <p className="text-muted-foreground text-center text-xs">
          {t("useScratchCode")}
        </p>

        <div className="mt-3 flex flex-col gap-3">
          <Button className="w-full" size="lg" type="submit">
            {t("common:validate")}
          </Button>
          <Button
            className="w-full"
            onClick={backToSignin}
            size="lg"
            type="button"
            variant="outline"
          >
            {t("common:cancel")}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
}

export default LoginAdmin2faForm;
